import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetPagedAllDepartments,
  onCreateDepartment,
  onDeleteDepartment,
  onGetDepartment,
  onUpdateDepartment,
} from '../../../app/modules/system-definitions/components/departments/core/_requests'
import {
  onGetFaculties,
  onGetUniversities,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface DepartmentState {
  departments: any
  department: any
  faculties: any
  universities: any
  isLoading: boolean
}
const initialState = {
  departments: [],
  faculties: [],
  universities: [],
  department: null,
  isLoading: true,
} as DepartmentState

export const fetchUniversities = createAsyncThunk('department/fetchUniversities', async () => {
  const data: any = await onGetUniversities()
  return data.data.result
})

export const fetchFaculties = createAsyncThunk('department/fetchFaculties', async (param: any) => {
  const data: any = await onGetFaculties()
  return data.data.result
})

export const fetchDepartments = createAsyncThunk(
  'department/fetchDepartments',
  async (param: any) => {
    const data: any = await onGetPagedAllDepartments(param)
    return data.data.result
  }
)

export const fetchDepartment = createAsyncThunk(
  'department/fetchDepartment',
  async (param: any) => {
    const data: any = await onGetDepartment(param)
    return data.data.result
  }
)

export const updateDepartment = createAsyncThunk(
  'department/updateDepartment',
  async (param: any) => {
    const data: any = await onUpdateDepartment(param)
    return data.data
  }
)

export const createDepartment = createAsyncThunk(
  'department/createDepartment',
  async (param: any) => {
    const data: any = await onCreateDepartment(param)
    return data.data
  }
)

export const deleteDepartment = createAsyncThunk(
  'department/deleteDepartment',
  async (param: any) => {
    const data: any = await onDeleteDepartment(param)
    return data.data
  }
)

const departmentSlice = createSlice({
  name: 'department',
  initialState,
  reducers: {
    clearDepartments: (state) => {
      state.departments = []
    },
    clearDepartment: (state) => {
      state.department = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDepartments.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchDepartments.fulfilled, (state: any, action) => {
      state.departments = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchDepartments.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchDepartment.fulfilled, (state: any, action) => {
      state.department = action.payload
    })
    builder.addCase(fetchUniversities.fulfilled, (state: any, action) => {
      state.universities = action.payload.items
    })
    builder.addCase(fetchFaculties.fulfilled, (state: any, action) => {
      state.faculties = action.payload.items
    })
  },
})

export const {clearDepartments, clearDepartment, activateLoading} = departmentSlice.actions

export default departmentSlice.reducer
